<template>
  <component :is="onModal ? 'v-toolbar' : 'v-app-bar'" :app="!onModal" color="white">
    <logo v-if="inMain" theme="light" class="H10" :height="40" style="height: 40px" />
    <v-btn v-if="!inMain" color="primary darken-1" @click="goBack()" icon :class="{ 'ml-0': smAndUp }">
      <v-icon :size="mdAndUp ? 28 : 24" class="material-symbols-rounded" color="primary darken-1">arrow_back</v-icon>
    </v-btn>
    <span v-if="!inMain" class="H10 primary--text text--darken-1">
      <loading-field :value="pageTitle" :willHaveValue="sectionsWithTitle.includes($route.name)"/>
      </span>
    <v-spacer />
    <v-btn v-if="!inMain" color="primary darken-1" @click="goHome()" icon :class="{ 'ml-0': smAndUp }">
      <v-icon :size="mdAndUp ? 28 : 24" class="material-symbols-rounded" color="primary darken-1">home</v-icon>
    </v-btn>
    <v-divider v-if="!inMain && !inActivityReservationProcess" vertical class="toolbar-divider" />
    <v-btn v-if="!inMain && !inActivityReservationProcess" color="primary darken-1" @click.stop="showSideMenu" icon :class="{ 'ml-0': smAndUp }">
      <v-icon :size="mdAndUp ? 28 : 24" class="material-symbols-rounded" color="primary darken-1">menu</v-icon>
    </v-btn>
  </component>
</template>

<script>
import { textColor } from '@/lib/helpers/ColorUtils'
import { mapState, mapGetters } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'
import credentialMixins from '@/mixins/Credentials'
import routeNames from '@/router/routes'
import router from '@/router'

//  emitted events: goBack
export default {
  props: {
    emitGoBack: Boolean,
    onModal: Boolean,
  },
  data () {
    return {
      routeNames,
      showPasswordWarning: false,
      sectionsWithTitle: [
        routeNames.page_details.name,
        routeNames.main.name,
        routeNames.settings.name,
        routeNames.activity_reservations.name,
        routeNames.booking.name,
        routeNames.upcomingEvents.name,
      ],
      inActivityReservationProcess: false,
    }
  },
  computed: {
    ...mapGetters({ 
      getDashboardName: 'pages/getDashboardName',
      pageName: 'pages/pageName',
      historyLength: 'state/historyLength',
    }),
    pageTitle () {
      if (this.$route.name === routeNames.page_details.name) {
        return this.pageName
      } else {
        const dashboardName = this.getDashboardName({ routeName: this.$route.name })
        if (dashboardName) {
          return dashboardName
        } else {
          return ''
        }
      }
    },
    inMain () {
      return this.$route.name === routeNames.main.name
    },
    configuration () {
      return this.$store.state.service.configuration
    },
    customization () {
      if (this.configuration !== null) {
        return this.configuration.customization
      } else {
        return null
      }
    },
    compact () {
      if (this.customization !== null && this.customization.logo !== null) {
        return this.configuration.customization.logo.compact
      } else {
        return null
      }
    },
    appTitle () {
      if (this.customization !== null && this.customization.appTitle !== null) {
        let languageCode = this.$i18n.locale
        let appTitle = this.configuration.customization.appTitle.filter(
          (name) => name.languageCode === languageCode
        )[0]
        return appTitle.value
      } else {
        return null
      }
    },
    color () {
      return textColor(this.$vuetify.theme.themes.light.primary.base)
    },
    settings () {
      return this.$store.state.me.settings
    },
    ...mapState(['state']),
  },
  methods: {
    goBack () {
      if (this.emitGoBack) {
        this.$emit('goBack')
      } else if (!this.historyLength) {
        this.goHome()
      } else {
        router.go(-1)
      }
    },
    goHome () {
      router.push({ name: routeNames.main.name })
    },
    setFavicon (val) {
      var link = document.querySelector('link[rel*=\'icon\']')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = val
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    showSideMenu () {
      this.$store.commit('state/setShowSideMenu', true)
    },
  },
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
    LoadingField: () => import('@/components/app-components/LoadingField.vue'),
  },
  watch: {
    compact: function (val) {
      if (val !== null) {
        this.setFavicon(val)
      }
    },
    appTitle: function (val) {
      if (val !== null) {
        document.title = val
      }
    },
    settings: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (!newValue) {
          return
        }
        const credential = this.getCredentialFromToken(newValue.webappUserCredentials)
        if (!!credential && !credential.hasPassword) {
          this.showPasswordWarning = true
        } else {
          this.showPasswordWarning = false
        }
      },
    },
    $route (to, from) {
      const regex = /\/p\/([a-f0-9-]+)\/[/a-z0-9]*$/i
      this.inActivityReservationProcess = regex.test(to.path)
    },
  },
  created () {
    if (this.compact !== null) {
      this.setFavicon(this.compact)
    }
    if (this.appTitle !== null) {
      document.title = this.appTitle
    }
  },
  mixins: [
    vuetifyMixins,
    credentialMixins,
  ],
}
</script>

<style lang="scss">
.v-toolbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.v-app-bar, .v-toolbar {
  .v-btn {
    text-transform: none;
  }
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08) !important;
}
.toolbar-divider {
  height: 32.5px;
  min-height: 1px;
  place-self: center;
}
</style>
